import { useRef, useEffect } from 'react';
import { Swiper as SwiperComponent, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import { usePatternFuncs } from '../../../hooks/responsive/usePatternFuncs';
import { patternHandling } from '../../../js/patternHandling';

export function PatternTablet({ pattern, customer_id }) {
  const slides = [...(Array.isArray(pattern) ? pattern : [])].reverse();
  const { selectedIdx, handleClick, data, handleAddNewFile } = usePatternFuncs(slides, customer_id);

  const swiperRef = useRef(null);

  useEffect(() => {
    if (!(typeof selectedIdx === 'number')) return;
    swiperRef.current?.slideToLoop(selectedIdx, 500);
    patternHandling.selectedPattern(data[selectedIdx - 1]);
  }, [selectedIdx, data]);

  return (
    <SwiperComponent
      direction={'vertical'}
      slidesPerView={8}
      ref={swiperRef}
      initialSlide={selectedIdx}
      onSwiper={(swiper) => {
        swiperRef.current = swiper;
      }}
      onActiveIndexChange={(swiper) => {
        patternHandling.selectedPattern(data[swiper.realIndex - 1]);
      }}
      // loop
      centeredSlides={true}
      modules={[Pagination, Navigation]}
      className="mySwiper colorSwiper"
      style={{ height: '100%' }}
    >
      <SwiperSlide>
        <div
          className="slider-item-center"
          style={{
            width: '110px',
            height: '80px',
            background: 'black',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            margin: 'auto',
          }}
        >
          +
          <input
            className="fullOwner_opacity"
            style={{ width: '100%', height: '100%' }}
            type="file"
            id="myfile"
            name="myfile"
            accept="image/*"
            onChange={(e) => handleAddNewFile(e)}
            value=""
          />
        </div>
      </SwiperSlide>
      {data?.map((item, index) => (
        <SwiperSlide
          key={index + 1}
          onClick={handleClick(item, index + 1)}
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <img
            style={{
              margin: 'auto',
            }}
            src={item.Thumbnail}
            className="colorItem"
            alt="unknow"
          />
        </SwiperSlide>
      ))}
    </SwiperComponent>
  );
}
